import React, {Component} from 'react';
import './App.css';

import {BrowserRouter as Router, Route, Switch} from "react-router-dom";

import Home from "./component/Home";
import NoMatch from "./component/NoMatch";
import Pricing from "./component/Pricing";
import Product from "./component/Product";
import Features from "./component/Features";
import Contact from "./component/Contact";
import Terms from "./component/Terms";

class App extends Component {
    render() {
        return (
            <Router>
                <Switch>
                    <Route exact path="/" component={Home}/>
                    <Route exact path="/product" component={Product}/>
                    <Route exact path="/features" component={Features}/>
                    <Route exact path="/pricing" component={Pricing}/>
                    <Route exact path="/contact" component={Contact}/>
                    <Route exact path="/terms" component={Terms}/>
                    <Route path="*" component={NoMatch}/>
                </Switch>
            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js